import React, { useEffect } from 'react';

export const RedirectPage = ({ to }: { to?: string }) => {
  useEffect(() => {
    window.top.location.href = to || 'completed';
  });
  return <div>Redirecting...</div>;
};

export default RedirectPage;
